export default __webpack_public_path__ + "static/byc-e0abda7e2f273ffd28a2b2f4b049b746.svg";